<template>
  <div>
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <router-link to="/Families">
            <img src=".././../assets/logo_wbg.png" alt="Logo DyC SantaFe" width="83" height="30" />
          </router-link>
          <ul class="navbar-nav ms-3 me-2 mb-2 mb-lg-0">
            <li class="nav-item mt-2">
              <router-link class="btn btn-light ms-2 disabled" to="actualQuote">Cotización
                actual</router-link>
            </li>
            <li class="nav-item mt-2">
              <button class="btn btn-light ms-2 disabled" @click.prevent="reStartQuote"> Reiniciar
                cotización</button>
            </li>
            <li class="nav-item mt-2">
              <button class="btn btn-light float-end ms-5" @click.prevent="logOut">Cerrar Sesión</button>
            </li>
          </ul>
          <!-- <ul class="navbar-nav ms-auto me-auto mb-2 mb-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown">
                Perfil
              </a>
              <ul class="dropdown-menu">
                <li><a class="dropdown-item" href="#">Ver perfil</a></li>
                <li><a class="dropdown-item" @click.prevent="logOut">Cerrar Sesión</a></li>
              </ul>
            </li>
          </ul> -->
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    reStartQuote() { },
    logOut() {
      localStorage.removeItem("token");
      this.$router.push("/")
    }
  },
};
</script>
<style>
.link {
  text-decoration: none;
  font-weight: bold;
  color: #898a8e;
  margin-left: 10px;
  margin-top: auto;
}

.link:hover {
  color: black !important;
}

nav a.router-link-exact-active {
  color: black !important;
}
</style>